import React, { useEffect } from 'react'
import Highcharts from 'highcharts';
require('highcharts/modules/accessibility')(Highcharts);

export default function ExpenseBreakdownChart({summaryReports}) {
    function applyAccessibility(chart) {
      if (chart && chart.renderTo) {
      const svg = chart.renderTo.querySelector("svg.highcharts-root");
      if (svg) {
        setTimeout(() => {
          svg.setAttribute("role", "img");
          svg.setAttribute(
          "aria-label",
          "Expense Breakdown pie chart showing the distribution of cost."
          );

          const oldDesc = svg.querySelector("desc");
          if (oldDesc) oldDesc.remove();

          const desc = document.createElementNS("http://www.w3.org/2000/svg", "desc");
          desc.textContent =
          "This pie chart represents the breakdown of expenses into three categories: ordering cost, holding cost, and product cost.";
          svg.insertBefore(desc, svg.firstChild);
        },0);
      }
      }
    }
    var chart = {
        plotBackgroundColor: null,
        plotBorderWidth: null,
        plotShadow: false,
        events: { 
        render: function () {
            applyAccessibility(this);
        },
        redraw: function () {
            applyAccessibility(this);
        }
      }
    };
    var title = {
        text: 'Expense Breakdown',
        align: 'left',
        style:{
            fontSize:"14px"
        }
    };
    var credits = {
        enabled: false // Disable the Highcharts bottom link
    };
    var tooltip = {
        pointFormat: '<strong>{point.percentage:.2f}%</strong>'
    };
    var legend = {
        align: 'left',
        verticalAlign: 'bottom',
        x: 0,
        y: 0
    };

    var plotOptions = {
        pie: {
            // center: [140, 90],
            dataLabels: {
                enabled: false
            },

            showInLegend: false,
        }
    };
    var series = [{
        type: 'pie',
        data: [
            {
                name: 'Ordering Cost',
                y: (summaryReports?.FinancialSummary?.GrossOrderingCost / summaryReports?.FinancialSummary?.GrossCost)*100,
                //color: 'rgb(0, 48, 87)', // Set the background color for 'Ordering Cost'
                color: {
                    pattern: {
                      path: 'M 0 10 L 10 0',
                      width: 10,
                      height: 10,
                      color: '#FFFFFF',
                      backgroundColor: "rgb(0, 48, 87)"
            
                    }
                }
                
            },
            {
                name: 'Holding Cost',
                y: (summaryReports?.FinancialSummary?.GrossHoldingCost / summaryReports?.FinancialSummary?.GrossCost)*100,
                //color: 'rgb(210, 219, 14)', // Set the background color for 'Holding Cost'
                color: {
                    pattern: {
                      path: 'M 0 0 L 10 10 M 9 -1 L 11 1 M -1 9 L 1 11',
                      width: 10,
                      height: 10,
                      color: '#FFFFFF',
                      backgroundColor: 'rgb(210, 219, 14)'
                    },
                  }
                
            },
            {
                name: 'Product Cost',
                y: (summaryReports?.FinancialSummary?.GrossPurchaseCost / summaryReports?.FinancialSummary?.GrossCost)*100,
                //color: 'rgb(80, 87, 89)', // Set the background color for 'Product Cost'
                color: {
                    pattern: {
                        path: 'M 0 5 L 10 5', // Horizontal line
                        width: 10,
                        height: 10,
                        color: '#FFFFFF', // Line color (white)
                        backgroundColor: 'rgb(80, 87, 89)' // Background color (red)
                    }
            },
                
            }
        ],
        states: {
            inactive: {
                enabled: false
            }
        }
    }];
    var accessibility = {
        enabled: true,
        screenReaderSection: {
        beforeChartFormat: '' // disables their auto "Interactive chart" label
      }
    }
    var json = {};
    json.chart = chart;
    json.credits = credits;
    json.title = title;
    json.tooltip = tooltip;
    json.legend = legend;
    json.series = series;
    json.plotOptions = plotOptions;
    json.accessibility = accessibility;
    const initGraph = () => {
        Highcharts.chart("container", json);
    }
    useEffect(() => {
        initGraph();
    }, [summaryReports]);
    return (
        <div id="container" style={{height:"300px"}} title={title.text} aria-label='Expense Breakdown Chart'></div>
    )
}
